import { h } from 'preact';
import { Suspense, lazy } from 'preact/compat';

export const LazyComponent = importCallback => {
  const Component = lazy(importCallback);

  return props => {
    return (
      <Suspense fallback={null}>
        <Component {...props} />
      </Suspense>
    );
  };
};
